"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AppList_1 = require("./AppList");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return AppList_1.default; } });
